"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.embedMediaQuery = exports.mediaQuery = void 0;

var _index = require("./index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// .......... MEDIA QUERIES .......... //
// media queries
// http://giona.net/tools/css3-mediaquery-generator/


var mediaQuery = {
  customizeRailThin: "@media only screen and (min-width:".concat((0, _index.pxToEm)(800), ") and (max-width:").concat((0, _index.pxToEm)(1090), ")"),
  customizeInContentThin: "@media only screen and (min-width:".concat((0, _index.pxToEm)(800), ") and (max-width:").concat((0, _index.pxToEm)(1400), ")"),
  customizeThinnest: "@media only screen and (min-width:".concat((0, _index.pxToEm)(0), ") and (max-width:").concat((0, _index.pxToEm)(799), ")"),
  homepageDateDropdown: "@media only screen and (min-width:".concat((0, _index.pxToEm)(700), ") and (max-width:").concat((0, _index.pxToEm)(1000), ")"),
  reportDetailPage: "@media only screen and (min-width:".concat((0, _index.pxToEm)(0), ") and (max-width:").concat((0, _index.pxToEm)(1260), ")"),
  medium: "@media only screen and (min-width:".concat((0, _index.pxToEm)(0), ") and (max-width:").concat((0, _index.pxToEm)(1200), ")"),
  thinnest: "@media only screen and (min-width:".concat((0, _index.pxToEm)(0), ") and (max-width:").concat((0, _index.pxToEm)(700), ")")
};
exports.mediaQuery = mediaQuery;
var embedMediaQuery = {
  wide: "@media only screen and (min-width:".concat((0, _index.pxToEm)(560), ")"),
  medium: "@media only screen and (min-width:".concat((0, _index.pxToEm)(400), ") and (max-width:").concat((0, _index.pxToEm)(560), ")"),
  thin: "@media only screen and (min-width:".concat((0, _index.pxToEm)(0), ") and (max-width:").concat((0, _index.pxToEm)(270), ")"),
  tall: "@media only screen and (max-height:".concat((0, _index.pxToEm)(450), ")"),
  short: "@media only screen and (max-height:".concat((0, _index.pxToEm)(250), ")")
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.embedMediaQuery = embedMediaQuery;